import styled, { css } from 'styled-components';
import { DiffType } from '@ardoq/data-model';
import {
  visualDiffHoverStyleRegular,
  visualDiffHoverStyleRemoved,
  visualDiffHoverStyleUnchanged,
} from './styles';

const EdgePathBase = styled.path<{ $diffType: DiffType }>`
  ${({ $diffType }) => {
    switch ($diffType) {
      case DiffType.ADDED:
      case DiffType.REMOVED:
      case DiffType.CHANGED:
      case DiffType.UNCHANGED:
        return css`
          stroke: black !important;
          color: hsl(0, 0%, 50%) !important;
        `;
      default:
        return '';
    }
  }}
`;
export const EdgePath = styled(EdgePathBase)`
  fill: none;
`;
export const hoverPathCss = css`
  &&&&&& {
    stroke-width: 16;
    stroke-dasharray: none;
  }
  &:hover {
    opacity: 0.32;
  }
  .visual-diff-added &,
  .visual-diff-removed &,
  .visual-diff-changed &,
  .visual-diff-unchanged & {
    ${visualDiffHoverStyleRegular}
  }

  .visual-diff-removed & {
    ${visualDiffHoverStyleRemoved}
  }

  .visual-diff-unchanged & {
    ${visualDiffHoverStyleUnchanged}
  }
`;
export const HoverPath = styled(EdgePathBase)<{ $isSelected?: boolean }>`
  ${hoverPathCss}
  opacity: ${props => (props.$isSelected ? '0.32' : '0')};
`;
